<template>



  <div id="app">

<!--
      ------------------------------Avio---------------------------
      Rev 05.06 del 11/08/2026


Stile parametrico:

                   <b-row >
                      <b-col  class=" p-2 " :style="uvStyle" > 
                        <p style=" font-size: 1rem;"> <b>{{gettextnew('Rischio UV')}}</b></p>
                      </b-col>
                      <b-col  class=" p-2 " :style="uvStyle">
                        <p 
                         v-if="tipo_sensore =='tempest'"> 
                         <b>{{uv_index}} - {{gettextnew(uv)}}</b></p>
                        <p 
                         v-else> 
                         <b>{{gettextnew('Non determinato')}}</b></p>
                      </b-col>

                    </b-row>



        this.uvStyle="backgroundColor: "+ this.uv_color;










    <div v-if="windowWidth < 700 " >
    <div :style="{color: ' #f67e7e'}" >
       <p class="font-italic"> <b>{{gettextnew("Per una visione ottimale ruotare lo schermo dello smartphone orizzontalmente!")}} </b></p>
    </div>
    </div>
-->


    <header class="header">

      <div class="container-riga">
        <div class="colonna colonna">
          <img alt="Vue logo" :src="Header_Page">
        </div>

        <div class="colonna colonna-piccola text-center"> 
          <div class="d-inline-block"> 
              <img
                :src="isPlaying ? imgOn : imgOff"
                alt="Toggle Audio"
                @click="toggleAudio"
                style="cursor: pointer; width: 200px; height: auto;"
              />
          </div>        
            <p style="color:black; background-color:#ffffff; font-size: 0.8rem; margin: 0; padding-top: 5px;">
                <b>{{gettextnew('Click per')}} ALIS (Avio Local Information Service)</b>
            </p>
        </div>

        <div class="colonna colonna-piccola ">
          <article class=" is-parent box notification is-info "
            v-bind:class="{'is-danger': stato == 3 || stato == 4 || messaggio_stato_sensore_meteo != null,
            'is-info': stato == 0 && messaggio_stato_sensore_meteo == null}"> 

            <b> 
              <p style=" text-align: center; font-size: 0.8rem;">{{formattedDateTime}} <br> {{gettextnew(Messaggio_Stato)}}  <br>{{messaggio_stato_sensore_meteo}}</p>
              <p align="left" style=" font-size: 0.8rem;">  
                {{gettextnew('Inizio crepuscolo')}}: <b>{{getTwentyFourHourTime(civil_twilight_begin)}} </b> <br> 
                {{gettextnew('Sorge')}}: <b>{{getTwentyFourHourTime(sunrise)}} </b> <br> 
                {{gettextnew('Tramonta')}}: <b>{{getTwentyFourHourTime(sunset)}}</b> <br> 
                {{gettextnew('Fine crepuscolo')}}: <b>{{getTwentyFourHourTime(civil_twilight_end)}} </b>
              </p>
            </b>
          </article>
        </div>
      </div>

      <!------------BOX ESSENZIALE------------------------------------------->
      <div class="container-riga align-items-center">

        <div class="colonna d-flex justify-content-center align-items-center">
          <b-card-group v-if="pista">
            <b-card
              :img-src="require(`@/assets/${pista}.png`)"
              img-alt="Card Image"
              img-right 
              class="mb-1"
              style="max-width: 160px;">
              <div class="card-content is-overlay">
                <br>
                <figure class="image is-96x96">
                  <img src="@/assets/windsock3.gif" :style="{ transform: `rotate(${dvento || 0}deg)` }">
                </figure>
              </div>
            </b-card>
          </b-card-group>
        </div>

        <div class="colonna colonna-larga">

          <!-- VENTO -->
          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> <b>{{gettextnew('Vento')}}</b></p>                                         
            </b-col>
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold;" :style="boxEssenzialeTextStyle"> 
                <font :color="Wind_Color"><b> {{dvento}}° {{Number(wind_kt)}} Kt </b></font>
              </p>
            </b-col>
          </b-row >

          <!-- HEADWIND -->
          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> <b>{{gettextnew('Headwind')}}</b></p>                                         
            </b-col>
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold;" :style="boxEssenzialeTextStyle">
                <font :color="Wind_Color"><b>{{ HeadWind_kts }} Kt</b></font>
              </p>
            </b-col>
          </b-row >

          <!-- CROSSWIND -->
          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> <b>{{gettextnew('Crosswind')}}</b></p>                                         
            </b-col>
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold;" :style="boxEssenzialeTextStyle">
                <font :color="Trav_VVento_traverso_color">
                  <b>{{ Trav_VVento_traverso }} Kt <span v-if="CrossWind_Lato" style="font-size: 1.2rem; font-weight: normal;">{{ CrossWind_Lato }}</span></b>
                </font>
              </p>
            </b-col>
          </b-row >

          <!-- QNH -->
          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> 
                    <b>{{gettextnew('QNH')}}:</b>
                    
                    <!-- Icona i cerchiata cliccabile -->
                    <span 
                      class="info-icon" 
                      @click.stop="showFieldInfo('QNH')" 
                      :title="gettextnew('Clicca per informazioni')">
                      &#9432;
                    </span>
                  </p>
             </b-col>
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold;" :style="boxEssenzialeTextStyle"> 
                <b>{{QNH}} hPa <span style="font-size: 1.2rem; font-weight: normal;">({{qnh_mmHg}} mmHg)  ({{qnh_inHg}} inHg)</span></b>
              </p>
            </b-col>
          </b-row >

          <!-- DENSITY ALTITUDE -->
          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> <b>{{gettextnew('Density Altitude')}}: </b>
                    <!-- Icona i cerchiata cliccabile -->
                    <span 
                      class="info-icon" 
                      @click.stop="showFieldInfo('Density_Altitude')" 
                      :title="gettextnew('Clicca per informazioni')">
                      &#9432;
                    </span>
              
              </p>                                         
            </b-col>
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold;" :style="boxEssenzialeTextStyle">
                <b><font :color="density_Color"> {{Number(density).toLocaleString()}} {{gettextnew('piedi')}} </font></b>
              </p>
            </b-col>
          </b-row >

          <!-- PISTA -->
          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> <b>{{gettextnew('Pista')}}:</b></p>                                         
            </b-col>
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold;" :style="boxEssenzialeTextStyle"> 
                <font color="#1E40AF"><b>{{Pista_Attiva_Vis}} </b></font>
              </p>
            </b-col>
          </b-row>

          <b-row style="text-align: center" v-if="INDICE0">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle">
                <font :color="visibilita_Color"><b>{{gettextnew(INDICE0.visibilita)}}</b></font>
              </p>
            </b-col>
          </b-row>

          <b-row v-if="tipologia == 'Idrosuperficie'">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle">
                <font :color="Moto_Ondoso_Color"><b>{{gettextnew("Altezza Onde Significative")}} {{Moto_Ondoso}} {{gettextnew("metri")}}</b></font>
              </p>
            </b-col>
          </b-row>

          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> 
              <b>AIRMET <span v-if="airmetData && airmetData.fir" style="font-size: 1.1rem; font-weight: normal;">({{ airmetData.fir }})</span>:</b>
                    <span 
                      class="info-icon" 
                      @click.stop="showFieldInfo('AIRMET')" 
                      :title="gettextnew('Clicca per informazioni')">
                      &#9432;
                    </span>
              </p>                                         
            </b-col>
            <b-col class="p-1" :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
                <p style="font-weight: bold; line-height: 1.2;" :style="boxEssenzialeTextStyle">
                  <span v-if="airmetData && airmetData.alerts && airmetData.alerts.length > 0">
                    <span 
                      v-for="(alertStr, index) in airmetData.alerts" 
                      :key="'airmet-'+index" 
                      style="color: #c2410c; display: block; font-size: 1.1rem; cursor: pointer;"
                      :title="decodeMetAdvisory(alertStr)">
                      {{ alertStr }}
                      <br>
                      <small style="color: #4b5563; font-weight: normal; font-size: 0.85rem;">
                        💡 {{ decodeMetAdvisory(alertStr) }}
                      </small>
                    </span>
                  </span>
                  <span v-else style="font-size: 1.2rem; font-weight: normal;" class="text-muted font-italic">
                    {{ gettextnew('Nessun avviso') }}
                  </span>
                </p>
              </b-col>
          </b-row >

          <b-row style="text-align: left">
            <b-col class=" p-1 " :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p :style="boxEssenzialeTextStyle"> 
              <b>SIGMET <span v-if="sigmetData && sigmetData.fir" style="font-size: 1.1rem; font-weight: normal;">({{ sigmetData.fir }})</span>:</b>
                    <span 
                      class="info-icon" 
                      @click.stop="showFieldInfo('SIGMET')" 
                      :title="gettextnew('Clicca per informazioni')">
                      &#9432;
                    </span>
              </p>                                         
            </b-col>
            <b-col class="p-1" :style="{ backgroundColor: boxEssenziateBg, fontSize: '1.5rem' }">
              <p style="font-weight: bold; line-height: 1.2;" :style="boxEssenzialeTextStyle">
                <span v-if="sigmetData && sigmetData.alerts && sigmetData.alerts.length > 0">
                  <span 
                    v-for="(alertStr, index) in sigmetData.alerts" 
                    :key="'sigmet-'+index" 
                    style="color: #c2410c; display: block; font-size: 1.1rem; cursor: pointer;"
                    :title="decodeMetAdvisory(alertStr)">
                    {{ alertStr }}
                    <br>
                    <small style="color: #4b5563; font-weight: normal; font-size: 0.85rem;">
                      💡 {{ decodeMetAdvisory(alertStr) }}
                    </small>
                  </span>
                </span>
                <span v-else style="font-size: 1.2rem; font-weight: normal;" class="text-muted font-italic">
                  {{ gettextnew('Nessun avviso') }}
                </span>
              </p>
            </b-col>
          </b-row >

          <div v-if="airmetData && airmetData.updated_at" class="text-right pr-2" style="font-size: 0.75rem; color: rgba(255,255,255,0.5); background-color: rgba(0,0,0,0.05); margin-top: 2px; border-radius: 3px;">
            Ref: {{ airmetData.updated_at }}
          </div>

        </div>

        <div class="colonna" style="text-align: center">
          <a href="javascript:;" v-on:click="openWindy()" >
            <B>{{gettextnew('Apri Windy')}}</B>
          </a>
          <div>
            <iframe width="100%" height="350" :src="Windy" frameborder="0"></iframe>
          </div>
        </div>

      </div>
      <!------------BOX ESSENZIALE------------------------------------------->

      <BR v-if="Avvisi_Manutenzione !== ''" fluid="auto"></BR>

      <b-container v-if="Avvisi_Manutenzione !== ''" fluid="auto">
        <b-row class="ml-2">
          <b-col md="5" style="background-color:#ffcc00;"> 
            <B>
              <p align="center"> {{gettextnew('AVVISO DI SERVIZIO')}} </p>
              <p align='left'> {{gettextnew('Valido dal giorno')}}: {{Data_Inizio_Avvisi_Manutenzione}} {{gettextnew('ora')}}: {{Ora_Inizio_Avvisi_Manutenzione}} {{gettextnew('al giorno')}}: {{Data_Fine_Avvisi_Manutenzione}} {{gettextnew('ora')}}: {{Ora_Fine_Avvisi_Manutenzione}} </p>
              <div style="white-space: pre-line;" v-html="Avvisi_Manutenzione"></div>
            </B>
          </b-col>
        </b-row>
      </b-container>

    </header>

    <a :href="Home_Page_xSite">
      <img src="https://www.climavia.city/Back.svg" style="position: absolute; top: 10px; left: 10px; height: 5%; width: 5%;z-index: 20">
    </a>

    <article class="tile is-child notification is-primary "
      v-bind:class="{'is-danger': messaggio_stato_sensore_meteo != null ,
      'is-light': messaggio_stato_sensore_meteo == null}">

      <b-row class="mb-1">
        <b-col class="p-0 text-white" style="background-color:#007bff; font-size: 1.5rem;">
          <p v-if="stato == 3 || stato == 4 || messaggio_stato_sensore_meteo != null"
             style="color: #ffb3b3; text-align: center;"> 
            <strong>
              {{ gettextnew('ATTENZIONE - DATI METEO LOCALI NON DISPONIBILI') }}
            </strong>
          </p>
        </b-col>
      </b-row>

      <div class="container-riga">
        <div class="colonna"> 
          <font :color="black">
            <b-row style="text-align: center">
              <b-col class="p-0 text-white" style="background-color:#007bff; font-size: 1rem;">
                <p><b>{{gettextnew('Vento')}}</b></p>
              </b-col>
            </b-row>

            <div class="has-text-left">
              <b-container fluid="auto">

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{text_raffica1}}</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><font :color="Raffica_Color"><b>{{text_raffica2}} </b></font></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Headwind')}}</b></p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><font :color="Wind_Color"><b>{{ HeadWind_kts }} Kt</b></font></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Crosswind')}}</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><font :color="Trav_VVento_traverso_color"><b>{{ Trav_VVento_traverso }} Kt {{ CrossWind_Lato }}</b></font></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('LL Wind Shear')}}</b></p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><font :color="LLWS_Color"><b>PROB {{LLWS}}% LLWS</b></font></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Vento ultimi 15 min.')}}:</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>Max {{Number(Wind_Max_15_kt).toLocaleString()}} Kt {{gettextnew('alle')}} {{data_Max_15}}</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Vento ultimi 60 min.')}}:</b></p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>Max {{Number(Wind_Max_60_kt).toLocaleString()}} Kt {{gettextnew('alle')}} {{data_Max_60}}</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Vento oggi')}}:</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>Max {{Number(Wind_Max_day_kt).toLocaleString()}} Kt {{gettextnew('alle')}} {{data_Max_day}}</b></p>
                  </b-col>
                </b-row>

              </b-container>
            </div>
          </font>
        </div>

        <div class="colonna">
          <font :color="black">
            <b-container fluid="auto">
              <b-row style="text-align: center">
                <b-col class="p-0 text-white" style="background-color:#007bff; font-size: 1rem;">
                  <p><b>{{gettextnew('Temperatura')}}</b></p>
                </b-col>
              </b-row>

              <b-row style="text-align: center">
                <b-col class="p-2 " style="background-color:#ced4da; font-size: 1.5rem;">
                  <p><b>{{temperaturePlus}}{{Number(temperature)}}°C</b></p>
                </b-col>
              </b-row>

              <div class="has-text-left">
                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Temperatura Massima oggi')}}:</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{Tmp_Max_dayPlus}}{{Number(Tmp_Max_day).toLocaleString()}} °C {{gettextnew('alle')}} {{data_Tmp_Max_day}}</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Temperatura Minima oggi')}}:</b></p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{Tmp_Min_dayPlus}}{{Number(Tmp_Min_day).toLocaleString()}} °C {{gettextnew('alle')}} {{data_Tmp_Min_day}}</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Tendenza ultime 3hr')}}:</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{TrendTmp3HourPlus}}{{TrendTmp3Hour}}°C </b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Temp. Media')}}:</b></p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{TmpDayPlus}}{{Number(TmpDay)}}°C</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Rugiada')}}:</b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{dpPlus}}{{Number(dp)}}°C</b></p>
                  </b-col>
                </b-row>
              </div>

              <div class="has-text-left">
                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Percepita')}}:</b></p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{tpercepitaPlus}}{{Number(tpercepita)}}°C</b></p>   
                  </b-col>
                </b-row>
              </div>

            </b-container>
          </font>
        </div>

        <div class="colonna">
          <font :color="black">
            <b-container fluid="auto">
              <b-row style="text-align: center">
                <b-col class="p-0 text-white" style="background-color:#007bff; font-size: 1rem;">
                  <p><b>{{gettextnew("Condizioni dell'atmosfera")}}</b></p>
                </b-col>
              </b-row>

              <div class="has-text-left">
                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Umidità')}}:</b></p>                                 
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{hum}}%</b></p>                   
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Pressione')}}:</b></p>                                 
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b>{{QNH}} hPa </b> &nbsp;&nbsp;<img v-if="pressione" :src="require(`@/assets/${pressione}.png`)" width="10%" height="10%"></p>                   
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Tendenza ultime 3hr')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew(pressione_l)}} </b></p>
                  </b-col>
                </b-row>
     
                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Rischio Temporali')}}: </b></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b><font :color="Rischio_Temporali_Color">{{gettextnew(Rischio_Temporali)}}</font> </b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Rischio UV')}}</b></p>
                    <p v-if="tipo_sensore =='tempest'"> 
                      <a href="javascript:;" onClick="window.open('https://www.climavia.city/Images/UV-INDEX.png', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
                        <B>{{gettextnew('(Legenda)')}}</B>
                      </a>
                    </p>
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p v-if="tipo_sensore =='tempest'"> 
                      <b><font :color="uv_color"> {{uv_index}} - {{gettextnew(uv)}}</font></b>
                    </p>
                    <p v-else> 
                      <b>{{gettextnew('Non determinato')}}</b>
                    </p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><font :color="Rain_Color"><b>{{gettextnew(Rain_Portal)}}</b></font></p>
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p v-if="Rain == 'Piove' && tipo_sensore =='tempest'"> 
                      <font :color="intensita_pioggia_color"><b>{{gettextnew(intensita_pioggia_letter)}} - {{Number(intensita_pioggia).toLocaleString()}} mm/h</b></font>
                    </p>
                    <p v-else>
                      <font :color="Rain_Color"><b>{{gettextnew("Assenti")}}</b></font>
                    </p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Acqua Precipitabile')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b><font :color="Wmm_Color">{{Number(Wmm).toLocaleString()}} mm/m<sup>2</sup> </font></b></p>
                  </b-col>
                </b-row>

              </div>
            </b-container>
          </font>
        </div>

        <div class="colonna">
          <font :color="black">
            <b-container fluid="auto">
              <b-row style="text-align: center">
                <b-col class="p-0 text-white" style="background-color:#007bff; font-size: 1rem;">
                  <p><b>{{gettextnew('AVIO')}}</b></p>
                </b-col>
              </b-row>
              <div class="has-text-left">
                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Alt.Pista')}}:</b></p>                                 
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b>{{Number(EQFE).toLocaleString()}} {{gettextnew('piedi')}}</b></p>                   
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('QFE')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b>{{QFE}} hPa</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('QNH')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b>{{QNH}} hPa</b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Density Altitude')}}: </b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b><font :color="density_Color"> {{Number(density).toLocaleString()}} {{gettextnew('piedi')}} </font> </b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Quota ')}} 0°C :</b></p>                                        
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b> {{Number(freezing).toLocaleString()}} {{gettextnew('piedi')}} </b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Umidità massima tra 0/-10 gradi C')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b><font :color="MAX_RELH_Color"> {{MAX_RELH}}{{Percent_chr}} </font></b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Quota ')}} -10°C :</b></p>                                        
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b>{{Number(menodieci).toLocaleString()}} {{gettextnew('piedi')}} </b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Altezza Base Nubi Termoconvettive')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b> {{Number(Base_Nubi).toLocaleString()}} {{gettextnew('piedi')}} </b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p><b>{{gettextnew('Conteggio Fulmini ultime 3 ore')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2 bg-white" style="font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b><font :color="lightning_Color">{{lightning_count}} </font></b></p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p><b>{{gettextnew('Distanza Fulmini MIN/MAX')}}:</b></p>                                        
                  </b-col>
                  <b-col class="p-2" style="background-color:#ced4da; font-size: 0.8rem;">
                    <p style="font-weight: bold;"><b><font :color="lightning_Color"> {{MIN_lightning_distance}}/{{MAX_lightning_distance}} Km </font></b></p>
                  </b-col>
                </b-row>

              </div>
            </b-container>
          </font>
        </div>

      </div>

      <div class="container-riga">
        <div class="colonna">
          <font :color="black">
            <EchartsLineChart 
              :chart-data="windData" 
              :title-text= "gettextnew('Vento e Raffiche')"
              :series-config="[
                { name: gettextnew('Vento nodi'), dataKey: 'value' },
                { name: gettextnew('Raffica nodi'), dataKey: 'gust' }
              ]"
            />
          </font>
        </div>

        <div class="colonna">
          <font :color="black">
            <EchartsLineChart 
              :chart-data="TempDPData" 
              :title-text="gettextnew('Temperatura e \n Dew_point')"
              :series-config="[
                { name: gettextnew('Temperatura °C'), dataKey: 'Temperature' },
                { name: gettextnew('Dew Point °C'), dataKey: 'dew_point' }
              ]"
            />
          </font>
        </div>

        <div class="colonna">
          <font :color="black">
            <EchartsLineChart 
              :chart-data="PressData" 
              :title-text="gettextnew('Pressione')"
              :series-config="[
                { name: gettextnew('hPa'), dataKey: 'value' }
              ]"
              :yAxisMin="PressMin" 
              :yAxisMax="PressMax"
              chart-type="line"
            />
          </font>
        </div>

        <div class="colonna">
          <font :color="black">
            <EchartsLineChart 
              :chart-data="DensityData" 
              :title-text="gettextnew('Density Altitude')"
              :series-config="[
                { name: gettextnew('Piedi'), dataKey: 'value' }
              ]"
              :yAxisMin="DensityMin" 
              :yAxisMax="DensityMax"
              chart-type="line"
            />
          </font>
        </div>
      </div>

      <div class="container-riga">
        <div class="colonna">
          <div class="container-riga" style="display: flex; justify-content: center; align-items: center; width: 100%; margin: 15px 0;">
            <p style="margin: 0; text-align: center; color: #000000; font-size: 20px;">
              <b>{{gettextnew('Click su immagine per il circuito di atterraggio')}}:</b>
            </p>
          </div>
          <a href="javascript:;" v-on:click="openSnap()">
            <center><img
              :src="Camera2" onerror="this.src='https://www.climavia.city/Images/loading.png';"
              alt="Vs RWY 22 "
              responsive="true"
              TARGET="_blank"
            ></center>
          </a>
        </div>
        <div class="colonna">
          <div class="container-riga" style="display: flex; justify-content: center; align-items: center; width: 100%; margin: 15px 0;">
            <p style="margin: 0; text-align: center; color: #000000; font-size: 20px;">
              <b>{{gettextnew('Click su immagine per il circuito di atterraggio')}}:</b>
            </p>
          </div>
          <a href="javascript:;" v-on:click="openSnap()">
            <center><img
              :src="Camera" onerror="this.src='https://www.climavia.city/Images/loading.png';"
              alt="Vs RWY 04"
              responsive="true"
              TARGET="_blank"
            ></center>
          </a>
        </div>
      </div>

      <BR></BR>

      <div class="container-riga" v-if="Numero_Camere > '2' || Numero_Camere == '3'">
        <div class="colonna">
          <a href="javascript:;" v-on:click="openSnap()">
            <img
              :src="Camera3" onerror="this.src='https://www.climavia.city/Images/loading.png';"
              alt=""
              responsive="true"
              TARGET="_blank"
            >
          </a>
        </div>
        <div class="colonna">
          <a href="javascript:;" v-on:click="openSnap()" v-if="Numero_Camere == '4'">
            <img
              :src="Camera4" onerror="this.src='https://www.climavia.city/Images/loading.png';"
              alt=""
              responsive="true"
              TARGET="_blank"
            >
          </a>
        </div>
      </div>

    </article>

    <div class="container-riga" align="center">
      <article class="tile is-child notification is-primary is-light">
        <a href="javascript:;" onClick="window.open('https://www.meteoam.it/it/swll', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
          <B> {{gettextnew('Apri Low Level SIGWX Chart')}} (Aeronautica Militare Italiana)</B>
        </a>
      </article>
    </div>

    <div class="container-riga">
      <div class="colonna">
        <a href="javascript:;" v-on:click="openSWLL_00()">
          <img :src="SWLL_00" width="100%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="SWLL_00" responsive="true" TARGET="_blank">
        </a>
      </div>
      <div class="colonna">
        <a href="javascript:;" v-on:click="openSWLL_06()">
          <img :src="SWLL_06" width="100%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="SWLL_06'" responsive="true" TARGET="_blank">
        </a>
      </div>
      <div class="colonna">
        <a href="javascript:;" v-on:click="openSWLL_12()">
          <img :src="SWLL_12" width="100%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="SWLL_12" responsive="true" TARGET="_blank">
        </a>
      </div>
      <div class="colonna">
        <a href="javascript:;" v-on:click="openSWLL_18()">
          <img :src="SWLL_18" width="100%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="SWLL_18'" responsive="true" TARGET="_blank">
        </a>
      </div>
    </div>

    <div class="container-riga">
      <div class="colonna">
        <div class="tile is-parent">
          <article class="tile is-child notification is-primary is-light">
            <p style="text-align: center" class="title">
              {{ gettextnew('METAR distanza max ') }}{{ (INDICE0.max_distanza_metar_taf / 1.852).toFixed(0) }} NM
            </p>
            <p v-for="(item, index) in getArray" :key="'metar-' + index" class="has-text-left">
              <B>{{ item.nome }} ---</B> {{ item.metar }}
              <br>
            </p>
          </article>
        </div>
      </div>

      <div class="colonna">
        <div class="tile is-parent">
          <article class="tile is-child notification is-primary is-light">
            <p style="text-align: center" class="title">
              {{ gettextnew('TAF distanza max ') }}{{ (INDICE0.max_distanza_metar_taf / 1.852).toFixed(0) }} NM
            </p>
            <p v-for="(item, index) in getTafArray" :key="'taf-' + index" class="has-text-left">
              <B>{{ item.nome_taf }} ---</B> {{ item.taf }}
              <br>
            </p>
          </article>
        </div>
      </div>
    </div>

    <div class="tile is-parent">
      <article class="tile is-child notification is-primary is-light"
        v-bind:class="{'is-danger': stato == 3 || stato == 4 || messaggio_stato_sensore_meteo != null}">

        <div class="content">

          <div class="container-riga">
            <div class="colonna" style="text-align: center">
              <a href="javascript:;" onClick="window.open('https://www.climavia.city/Images/Metar_Legenda2.pdf', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
                <B>{{gettextnew('Apri Legenda Carta Meteo')}}</B>
              </a>
              <br>
              <a href="javascript:;" v-on:click="openCarta()">
                <img :src="Carta" width="100%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="Carta Meteorologica" responsive="true" TARGET="_blank">
              </a>
            </div>

            <div class="colonna" style="text-align: center">
              <a href="javascript:;" v-on:click="openSat24()">
                <B>{{gettextnew('Apri Sat24')}}</B><br>
              </a>
              <div>
                <iframe style="height:281px;width:90%;max-width:600px;pointer-events: none;" :src="Sat24_Iframe"></iframe>
              </div>
            </div>

            <div class="colonna" style="text-align: center">
              <a href="javascript:;" onClick="window.open('https://radar.wo-cloud.com/pwa/?zoom=5&amp;placemark=41.8919,12.5113&amp;layer=WetterRadar&amp;loop=true&amp;period=periodPrognose24h&amp;center=41.88,12.48&amp;tz=Europe/Rome&amp;tf=HH:mm&amp;windunit=kmh&amp;lang=it', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
                <B>{{gettextnew('Apri Meteo&Radar')}}</B>
              </a>
              <div>
                <iframe _ngcontent-serverapp-c128="" id="radarIframe" src="https://radar.wo-cloud.com/pwa/?zoom=5&amp;placemark=41.8919,12.5113&amp;layer=WetterRadar&amp;loop=true&amp;period=periodPrognose24h&amp;center=41.88,12.48&amp;tz=Europe/Rome&amp;tf=HH:mm&amp;windunit=kmh&amp;lang=it" width="100%" height="250" title="Radar meteo"></iframe>
              </div>
            </div>
          </div>

          <BR></BR>

          <div class="container-riga">
            <div class="colonna" style="text-align: center">
              <B>{{gettextnew('EDR (Eddy Dissipation Rate)/CAT (Clear Air Turbulence) Chart')}}</B>
              <span 
                    class="info-icon" 
                    @click.stop="showFieldInfo('EDR_CAT')" 
                    :title="gettextnew('Clicca per informazioni')">
                    &#9432;
                  </span>
              <a href="javascript:;" v-on:click="openEDR1()">
                <BR></BR>
                <img :src="EDR1" width="70%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="" responsive="true" TARGET="_blank">
              </a>
            </div>
            <div class="colonna" style="text-align: center">
              <B>{{gettextnew('Vertical Wind Gradient Chart')}}</B>
              <span 
                    class="info-icon" 
                    @click.stop="showFieldInfo('WIND_GRADIENT')" 
                    :title="gettextnew('Clicca per informazioni')">
                    &#9432;
                  </span>
              <BR></BR>
              <a href="javascript:;" v-on:click="openEDR2()">
                <img :src="EDR2" width="70%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="" responsive="true" TARGET="_blank">
              </a>
            </div>
            <div class="colonna" style="text-align: center">
              <B>{{gettextnew('Vertical Humidity and Temperature Chart')}}</B>
              <span 
                    class="info-icon" 
                    @click.stop="showFieldInfo('GA_ICING')" 
                    :title="gettextnew('Clicca per informazioni')">
                    &#9432;
                  </span>
              <BR></BR>
              <a href="javascript:;" v-on:click="openEDR3()">
                <img :src="EDR3" width="70%" height="281" onerror="this.src='https://www.climavia.city/Images/loading.png';" alt="" responsive="true" TARGET="_blank">
              </a>
            </div>
          </div>

          <BR></BR>

          <div class="container-riga">
            <div class="colonna" style="text-align: center">
              <b-col class="p-0 text-white mb-2" style="background-color:#007bff; font-size: 1.5rem;">
                <a href="javascript:;" onClick="window.open('https://www.meteoam.it/it/mappa-previsioni-osservazioni', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
                  <B>{{gettextnew('Apri Previsioni Meteo')}} <a style="background-color:#007bff; font-size: 0.8rem;">(Aeronautica Militare Italiana)</a></B>
                </a>
              </b-col>
            </div>

            <div class="colonna" style="text-align: center">
              <b-col class="p-0 text-white mb-2" style="background-color:#007bff; font-size: 1.5rem;">
                <a href="javascript:;" onClick="window.open('https://www.meteoam.it/it/previsioni-testuali', 'Legenda', 'width=1000, height=600, resizable, status, scrollbars=1, location');">
                  <B>{{gettextnew('Apri Previsioni Testuali')}} <a style="background-color:#007bff; font-size: 0.8rem;">(Aeronautica Militare Italiana)</a></B>
                </a>
              </b-col>
            </div>
          </div>

        </div>

      </article>

    </div>

    <!--------------------------------------------------------------FOOTER ----------------------------------------------------------->
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <br>
          <a href="javascript:;" v-on:click="openDisclaimer()">
            <img :src="require(`@/assets/Disclaimer.png`)" height="70px" width="150px" alt="Avio" align="center" responsive="true" target="_blank">
          </a>
        </p>

        <p style="font-size:15px; margin-top: 20px;">
          {{ legalTexts.notice }}
          <br>
          <a :href="legalTexts.cookieLink" target="_blank">{{ legalTexts.cookieLabel }}</a>
          |
          <a :href="legalTexts.privacyLink" target="_blank">{{ legalTexts.privacyLabel }}</a>
        </p>

        <p>&copy; Climavia contacts:<br>
          <a href="mailto:valerio.ferraguto@sistemifutura.it"><strong>Valerio Ferraguto</strong><br></a>
          <a href="mailto:giuseppe.zampatti@sistemifutura.it"><strong>Giuseppe Zampatti</strong><br></a> 
          <a href="mailto:giancarlo.ruggeri@sistemifutura.it"><strong>Giancarlo Ruggeri</strong><br></a> 
        </p>
        
        <p> Copyright © Sistemi Futura S.r.l. - All Rights Reserved </p>
        <p> P.iva 01300551007 - C. F. 04771120583 </p>
      </div>
    </footer>
    <!--------------------------------------------------------------END FOOTER ----------------------------------------------------------->
<!-- Modale per le spiegazioni dei campi -->
    <b-modal v-model="isInfoModalActive" :width="640" scroll="clip">
      <div class="card">
        <header class="card-header bg-primary">
          <p class="card-header-title text-white">
            {{ infoModalTitle }}
          </p>
        </header>

        <!-- Aggiunti max-height e overflow-y: auto -->
        <div class="card-content" style="max-height: 70vh; overflow-y: auto;">
          <div class="content text-dark has-text-left" style="white-space: pre-line; font-size: 0.95rem; text-align: left;">
            {{ infoModalContent }}
          </div>
        </div>

        <footer class="card-footer p-2 text-right">
          <b-button type="is-primary" @click="isInfoModalActive = false">
            OK
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>

</template>

<script>
import EchartsLineChart from './components/EchartsLineChart.vue';
import Vue from 'vue'
import Buefy from 'buefy'
import axios from 'axios';
import { CardPlugin, BootstrapVue } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(CardPlugin)
Vue.use(Buefy)
Vue.config.productionTip = false

function getCookie(name) {
  const cookies = document.cookie.split(';');
  let foundValue = null;
  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    if (parts[0].trim() === name) {
      foundValue = parts[1] ? decodeURIComponent(parts[1]) : '';
    }
  }
  return foundValue;
}

export default {
  name: 'App',

  components: {
    EchartsLineChart
  },

  data() {
    return {
      isInfoModalActive: false,
      infoModalContent: '',
      infoModalTitle: '',

      lang: 'it',
      siteData: null,
      airmetData: { updated_at: '', fir: '', alerts: [] },
      sigmetData: { updated_at: '', fir: '', alerts: [] },

      localeMap: {
        it: 'it-IT',
        en: 'en-US',
        fr: 'fr-FR',
        de: 'de-DE',
        es: 'es-ES',
        pt: 'pt-BR',
        'zh-cn': 'zh-CN',
        'zh-tw': 'zh-TW',
        ru: 'ru-RU',
        el: 'el-GR'
      },

      VentoData: [],
      PressData: [],
      PressMin: null,
      PressMax: null,
      windData: [],
      TempDPData: [],
      loadingPress: true, 
      loadingWind: true,
      loadingTmpDP: true,
      error: null,
      loadingDensity: true,
      DensityData: [],
      DensityMin: null,
      DensityMax: null,

      isPlaying: false,
      audio: null,
      audioURL: null,

      users: null,

      dirs:[['N','Tramontana'], ['NNE','Bora'], ['NE','Grecale'], ['ENE','Schiavo'], ['E','Levante'], ['ESE','Solano'], ['SE','Scirocco'], ['SSE','Africo'], ['S','Ostro'], ['SSW','Gauro'], ['SW','Libeccio'], ['WSW','Etesia'], ['W','Ponente'], ['WNW','Traversone'], ['NW','Maestrale'], ['NNW','Zefiro']],

      Scala_Beaufort : [
        ['Calma', 0, 1, 0],
        ['Bava di Vento', 1, 3, 1],
        ['Brezza Leggera', 3, 6, 2],
        ['Brezza Tesa', 6, 10, 3],
        ['Vento Moderato', 10, 16, 4],
        ['Vento Teso', 16, 21, 5],
        ['Vento Fresco', 21, 27, 6],
        ['Vento Forte', 27, 33, 7],
        ['Burrasca', 33, 40, 8],
        ['Burrasca Forte', 40, 47, 9],
        ['Tempesta', 47, 55, 10],
        ['Tempesta Violenta', 55, 63, 11],
        ['Uragano', 63, 999, 12]
      ],

      Scala_intensita_pioggia : [
        ['Molto leggera ', 0, 0.25, '#009900'],
        ['Leggera', 0.25, 1.00, '#009900'],
        ['Moderata', 1, 4, '#ff9900'],
        ['Forte', 4, 16, 'red'],
        ['Molto Forte', 16, 50, '#cc0000'],
        ['Eccezionale', 50, 999, '#cc0000']
      ],

      Scala_UV : [
        ['Basso', 0, 3, '#009900'],
        ['Moderato',3, 6, '#ffff00'],
        ['Alto', 6, 8, '#cc6600'],
        ['Molto Alto', 8, 11, 'red'],
        ['Eccezionale', 11, 999, '#cc0099']
      ],

      verde:"#009900",
      arancione:"#ff9900",
      rosso_forte:"#cc0000",
      blu:"#000099",
      black:"#000000",
      visibilita_Color:null,
      tipo_sensore:null,
      temperature:null,
      temperaturePlus:null,
      Tmp_Max_day:null,
      Tmp_Max_dayPlus:null,
      Tmp_Min_dayPlus:null,

      data_Tmp_Max_day:null,
      Tmp_Min_day:null,
      data_Tmp_Min_day:null,

      dp:null,
      dpPlus:null,
      tpercepita:null,
      tpercepitaPlus:null,
      hum:null,
      humPlus:null,
      TrendTmp3Hour:null,
      TrendTmp3HourPlus:null,
      TmpDay:null,
      TmpDayPlus:null,

      dvento:null,
      dvento_l:null,
      dvento_rosa:null,
      pista:'',
      wind_ms:null,
      wind_kt:null,
      Wind_Color:null,
      Vento_Nome:null,
      Vento_Beaufort:null,
      density:null,
      density_Color:null,
      freezing:null,
      DmediaR:null,
      DmediaR_ch:null,
      Draffica:null,
      Raffica:null,
      Raffica_Color:null,
      Devstd:null,
      VmediaR:null,
      Stringa_Vento:null,
      PRS_Ultimo_minuto:null,
      PRS_minuto_precedente:null,
      QFE:null,
      QNH:null,
      appo:[],
      sunrise:null,
      sunset:null,
      civil_twilight_begin:null,
      civil_twilight_end:null,
      pressione:null,
      pressione_l:null,
      componentKey: 0,
      Camera:null,
      Camera2:null,
      Camera3:null,
      Camera4:null,
      Carta:null,
      SWLL_00:null,
      SWLL_06:null,
      SWLL_12:null,
      SWLL_18:null,
      Isa:null,
      PMV:null,
      IoT:null,
      Message:null,
      stato:null,
      Pista_Attiva:null,
      Pista_Attiva_Vis:null,
      Tmp3Hour:null,
      Hum3Hour:null,
      TrendHum3Hour:null,
      EQFE:null,
      Messaggio_Stato:null,
      Camera_exists:'false',
      Camera2_exists:'false',
      Camera3_exists:'false',
      Camera4_exists:'false',
      Carta_exists:'false',
      Rischio_Temporali:null,
      Rischio_Temporali_Color:null,
      Header_Page:null,
      Sat24:null,
      Sat24ComponentKey:0,
      Sat24_Iframe:null,
      Disclaimer:null,
      ATIS:null,
      IndexSat24ComponentKey:0,
      lingua:"it",
      lingua_atis:null,
      messaggio_test:null,
      AVVISI:null,
      PREVISIONI:null,
      Home_Page_xSite:null,
      dst:'-0100',
      std:'-0000',
      Ora_Legale_Solare:null,
      Rain:null,
      Rain_Portal:null,
      Rain_Color:"red",
      Wind_Max_15_kt:null,
      data_Max_15:null,
      Wind_Max_60_kt:null,
      data_Max_60:null,
      Wind_Max_day_kt:null,
      data_Max_day:null,
      Onda_Fredda:null,
      wbHour:null,
      TmpHour:null,
      iET:null,
      iET_Color:null,
      ET:null,
      intensita_pioggia:null,
      intensita_pioggia_letter:null,
      intensita_pioggia_color:null,
      uv:null,
      uv_index:null,
      uv_color:null,

      Trav_Pista:null,
      Trav_Dvento:null,
      Trav_VVento_kts:null,
      Trav_Angolo:null,
      Trav_VVento_traverso:null,
      Trav_VVento_traverso_color:null,
      HeadWind_kts: null,
      CrossWind_Lato: null,

      Trig_Pista1:null,
      Trig_Pista2:null,
      Trig_Pista1_ord:null,
      Trig_Pista2_ord:null,
      Trig_Trav1:null,
      Trig_Trav2:null,
      Trav_DAngolo:null,

      INDmedia:null,
      INDmedia_ch:null,
      IVmediaR:null,
      IFetch:null, 
      Moto_Ondoso:null,
      Moto_Ondoso_Color:null,
      tipologia:null,
      T_today:null,
      T_today_Plus:null,
      T_tomorrow:null,
      T_tomorrow_Plus:null,
      menodieci:null,
      LLWS:null,
      LLWS_Color:null,
      MAX_RELH:null,
      MAX_RELH_Color:null,
      Percent_chr:null,

      Avvisi_Manutenzione:null,
      Data_Inizio_Avvisi_Manutenzione:null,
      Ora_Inizio_Avvisi_Manutenzione:null,
      Data_Fine_Avvisi_Manutenzione:null,
      Ora_Fine_Avvisi_Manutenzione:null,

      windowWidth: window.innerWidth,

      stato_sensore_meteo:null,
      messaggio_stato_sensore_meteo:null,

      TK:null,
      phi:null,
      Ps:null,
      Wcm:null,
      Wmm:null,
      Wmm_Color:null,

      INDICE0: {
        visibilita: '',
        max_distanza_metar_taf: '--',
        tipo_sensore: '',
        precip_acc: 0,
        MAX_RELH: 'ND',
        menodieci: 0,
        LLWS: 'NA',
        T_today: '--',
        T_tomorrow: '--',
        uv_raw: 0,
        rain: '',
        tipologia: '',
        stato: 0,
        stato_sensore_meteo: '',
        dvento_gradi: 0,
        dvento: '',
        QFE: 0,
        QNH: 0,
        Delta_Prs: 0,
        EQFE: 0,
        Isa: '',
        wind_ave_ms: 0,
        pista_1: 0,
        hum: 0,
        Density_Altitude: 0,
        Freezing_Level: 0,
        tmp: 0,
        dp: 0,
        tpercepita: 0,
        num_piste: 1
      },
      INDICE1:null,
      INDICE2:null,
      INDICE3:null,
      INDICE4:null,
      INDICE5:null,
      INDICE6:null,
      INDICE7:null,
      INDICE8:null,
      INDICE9:null,
      INDICE10:null,
      INDICE11:null,
      INDICE12:null,
      Accessi:null,

      term:null,
      country:null,
      region:null,
      responseIp:null,
      urlIP:null,
      Numero_Camere:null,
      Base_Nubi:null,
      lightning_count:null,
      MAX_lightning_distance:null,
      MIN_lightning_distance:null,
      lightning_Color:null,
      Pista_Heli:null,
      EDR1:null,
      EDR2:null,
      EDR3:null,
      flag:0,
      language: null,
      langContext: { currentLang: 'it' },
      text_raffica1: '',
      text_raffica2: '',
      lat:null,
      lng:null,

      refreshCounter: 20,
      videoId: "doqBgKIBBh8"
    };
  },

  mounted() {
    this.fetchSigmetAirmet();
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },

  created: function() {
    console.log('document.cookie:', document.cookie);
    const cookieLang = getCookie('lang_avio');
    console.log('document.cookie:', document.cookie);
    this.lang = cookieLang || 'it';

    this.getAll();

    this.interval = setInterval(() => this.getAll(), 3000);

    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.interval);
    });

    this.LoadLanguage();

    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('IoT')){
      this.IoT=urlParams.get('IoT');
    } else {
      this.Message='Sito Inesistente';
      this.IoT='CLIMAVIA_Ali_Nettuno';
    }

    this.fetchVentoData();
    this.fetchWindData();
    this.fetchWTempData();
    this.fetchDensityData();

    this.showYourIp();

    this.Home_Page_xSite = "https://www.climavia.city/index_avio_xSite.php";

    const initialBuster = new Date().getTime();

    this.Camera4 = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera4.png?updated=" + initialBuster;
    this.Camera3 = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera3.png?updated=" + initialBuster;
    this.Camera2 = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera2.png?updated=" + initialBuster;
    this.Camera  = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera.png?updated=" + initialBuster;
    this.Carta   = "https://www.climavia.city/"+this.IoT+"/snapshot/carta/99_image_30.gif?updated=" + initialBuster;

    this.Disclaimer = "https://www.climavia.city/Disclaimer.pdf?updated=" + initialBuster;
    this.ATIS        = "https://www.climavia.city/index_avio_xSite_ATIS.php?updated=" + initialBuster;

    this.Sat24       = "https://www.sat24.com/it-it/country/it/hd?updated=" + this.Sat24ComponentKey;
    this.Sat24_Iframe = "https://widgets.meteox.com/it-IT/widgets/radar/country/it/satellite?z=3.5&updated=" + this.Sat24ComponentKey;

    this.SWLL_00 = "https://www.climavia.city/"+this.IoT+"/snapshot/carta/51_image_20.gif?updated=" + initialBuster;
    this.SWLL_06 = "https://www.climavia.city/"+this.IoT+"/snapshot/carta/52_image_20.gif?updated=" + initialBuster;
    this.SWLL_12 = "https://www.climavia.city/"+this.IoT+"/snapshot/carta/53_image_20.gif?updated=" + initialBuster;
    this.SWLL_18 = "https://www.climavia.city/"+this.IoT+"/snapshot/carta/54_image_20.gif?updated=" + initialBuster;

    this.PMV   = "https://www.climavia.city/"+this.IoT+"/snapshot/climavia.jpg?updated=" + initialBuster;
    this.Snap  = "https://www.climavia.city/"+this.IoT+"/snap.php";

    this.EDR1  = "https://www.climavia.city/"+this.IoT+"/snapshot/EDR/EDR_forecast.png?updated=" + initialBuster;
    this.EDR2  = "https://www.climavia.city/"+this.IoT+"/snapshot/EDR/EDR_wind_shear.png?updated=" + initialBuster;
    this.EDR3  = "https://www.climavia.city/"+this.IoT+"/snapshot/EDR/EDR_hum_temp.png?updated=" + initialBuster;

    this.Header_Page = "https://www.climavia.city/"+this.IoT+"/Header_VUE.png";
    this.Home_Avio_Dettagli = "https://www.climavia.city/index_avio_xSite_dettaglio.php?Sito=" + this.IoT;
    this.Home_Legenda_Dettagli = "https://www.climavia.city/Descrizione dei campi Portale CLIMAVIA AVIOSUPERFICE.pdf";
  },

  methods: {

decodeMetAdvisory(rawString) {
  if (!rawString) return '';

  let text = rawString;
  let details = [];

  // 1. Ceneri Vulcaniche ed Eruzioni (WV)
  if (text.includes('VA ERUPTION') || text.includes('VA CLD') || text.includes(' VOLCANO ')) {
    let vaInfo = `⚠️ ${this.gettextnew("Nube di cenere vulcanica")}`;
    const volcanoMatch = text.match(/MT\s+([A-Z]+)/);
    if (volcanoMatch) vaInfo += ` (${volcanoMatch[1]})`;
    details.push(vaInfo);
  }

  // 2. Cicloni Tropicali (WC)
  if (text.includes('TC ') || text.includes('TROPICAL CYCLONE')) {
    let tcInfo = `🌀 ${this.gettextnew("Ciclone Tropicale")}`;
    const tcNameMatch = text.match(/TC\s+([A-Z]+)/);
    if (tcNameMatch) tcInfo += ` (${tcNameMatch[1]})`;
    details.push(tcInfo);
  }

  // 3. Nubi Radioattive
  if (text.includes('RDOACT CLD')) {
    details.push(`☢️ ${this.gettextnew("Nube radioattiva")}`);
  }

  // 4. Tempeste di Sabbia / Polvere
  if (text.includes('HVY SS')) details.push(`⏳ ${this.gettextnew("Tempesta di sabbia forte")}`);
  if (text.includes('HVY DS')) details.push(`🌫️ ${this.gettextnew("Tempesta di polvere forte")}`);

  // 5. Temporali e Fenomeni Convettivi (WS / AIRMET)
  if (text.includes('EMBD TS')) details.push(this.gettextnew("Temporali incassati nelle nubi (difficili da vedere in VFR)"));
  else if (text.includes('OBSC TS')) details.push(this.gettextnew("Temporali nascosti da foschia/nubi"));
  else if (text.includes('SQL TS')) details.push(this.gettextnew("Temporali in linea di groppo"));
  else if (text.includes('FRQ TS')) details.push(this.gettextnew("Frequenti temporali"));
  else if (text.includes('ISOL TS')) details.push(this.gettextnew("Temporali isolati"));
  else if (text.includes('OCNL TS')) details.push(this.gettextnew("Temporali occasionali"));
  else if (text.includes('TS')) details.push(this.gettextnew("Temporali"));

  if (text.includes('GR')) details.push(this.gettextnew("Presenza di grandine associata a temporali"));

  // 6. Turbolenza, Ghiaccio Severi e Onde Orografiche
  if (text.includes('SEV TURB') || text.includes('CAT')) details.push(this.gettextnew("Turbolenza forte / in aria tersa (CAT)"));
  if (text.includes('SEV ICE')) details.push(this.gettextnew("Forte formazione di ghiaccio"));
  if (text.includes('FRZRN')) details.push(this.gettextnew("Pioggia congelante"));
  if (text.includes('SEV MTW')) details.push(this.gettextnew("Forti onde orografiche"));

  // 7. Limiti di Quota
  const layerMatch = text.match(/(SFC|FL\d{3})\/(FL\d{3})/);
  if (layerMatch) {
    const bottom = layerMatch[1] === 'SFC' ? this.gettextnew("Superficie") : `FL${layerMatch[1].replace('FL','')}`;
    const top = `FL${layerMatch[2].replace('FL','')}`;
    details.push(`${this.gettextnew("Quota")}: ${this.gettextnew("da")} ${bottom} ${this.gettextnew("a")} ${top}`);
  } else {
    // Riconosce sia "TOP FL150" che "TOP ABV FL150"
    const topMatch = text.match(/TOP\s+(?:ABV\s+)?(FL\d{3})/);
    if (topMatch) {
      const flNum = topMatch[1].replace('FL', '');
      const flFeet = parseInt(flNum, 10) * 100;
      const abvStr = text.includes('TOP ABV') ? 'oltre ' : '';
      details.push(`${this.gettextnew("Sommità nubi")} ${abvStr}FL${flNum} (~${flFeet.toLocaleString()} ft)`);
    }
  }

  // 8. Movimento e Velocità
  const dirMap = {
    N: 'Nord', NE: 'Nord-Est', E: 'Est', SE: 'Sud-Est',
    S: 'Sud', SW: 'Sud-Ovest', W: 'Ovest', NW: 'Nord-Ovest'
  };

  const movMatchWithSpeed = text.match(/MOV\s+([A-Z]{1,3})\s+(\d+KT)/);
  const movMatchSimple = text.match(/MOV\s+([A-Z]{1,3})/);

  if (movMatchWithSpeed) {
    const dirName = this.gettextnew(dirMap[movMatchWithSpeed[1]] || movMatchWithSpeed[1]);
    details.push(`${this.gettextnew("In movimento verso")} ${dirName} ${this.gettextnew("a")} ${movMatchWithSpeed[2].replace('KT', ' kt')}`);
  } else if (movMatchSimple) {
    const dirName = this.gettextnew(dirMap[movMatchSimple[1]] || movMatchSimple[1]);
    details.push(`${this.gettextnew("In movimento verso")} ${dirName}`);
  } else if (text.includes('STNR')) {
    details.push(this.gettextnew("Fenomeno stazionario"));
  }

  // 9. Tendenza
  if (text.includes('NC')) details.push(this.gettextnew("Nessun cambio d'intensità"));
  if (text.includes('INTSF')) details.push(this.gettextnew("In intensificazione"));
  if (text.includes('WKN')) details.push(this.gettextnew("In indebolimento"));

  // 10. AIRMET Specifici e Condizioni Bassa Quota (VFR/IFR)

  // Vento, Shear e Onde Orografiche Moderate
  if (text.includes('SFC WIND')) {
    const windSpeedMatch = text.match(/SFC WIND\s+(\d+KT)/);
    if (windSpeedMatch) {
      details.push(`${this.gettextnew("Vento forte in superficie")} (${windSpeedMatch[1].replace('KT', ' kt')})`);
    } else {
      details.push(this.gettextnew("Vento forte in superficie"));
    }
  }
  if (text.includes('MOD TURB')) details.push(this.gettextnew("Turbolenza moderata a bassa quota"));
  if (text.includes('LLWS')) details.push(this.gettextnew("Wind Shear a bassa quota"));
  if (text.includes('MOD MTW')) details.push(this.gettextnew("Onde orografiche moderate"));

  // Ghiaccio e Zero Termico
  if (text.includes('MOD ICE')) details.push(this.gettextnew("Ghiaccio moderato in nube"));
  if (text.includes('FZRA') || text.includes('FZDZ')) details.push(this.gettextnew("Precipitazione congelante"));

  const fzMatch = text.match(/(?:FZLVL|FREEZING LVL)\s+(?:ABV\s+|BLW\s+)?(FL\d{3}|\d+FT)/);
  if (fzMatch) {
    details.push(`${this.gettextnew("Zero termico")}: ${fzMatch[1]}`);
  }

  // Oscuramento Montagne e Visibilità
  if (text.includes('MT OBSCN') || text.includes('MOUNTAIN OBSCN')) {
    details.push(this.gettextnew("Rilievi montuosi oscurati da nubi/foschia"));
  }

  if (text.includes('SFC VIS') || text.includes('POOR VIS')) {
    const visDistMatch = text.match(/(?:VIS|SFC VIS)\s+(?:BLW\s+)?(\d+M|\d+KM)/);
    if (visDistMatch) {
      details.push(`${this.gettextnew("Visibilità ridotta in superficie")} (< ${visDistMatch[1]})`);
    } else {
      details.push(this.gettextnew("Visibilità ridotta in superficie"));
    }
  }

  // Fenomeni e Riduzione Visibilità
  if (text.includes(' FG ')) details.push(this.gettextnew("Presenza di nebbia"));
  if (text.includes(' BR ')) details.push(this.gettextnew("Presenza di foschia"));
  if (text.includes(' HZ ')) details.push(this.gettextnew("Presenza di caligine"));

  // Nubi Basse e Soffitto (Ceiling / Cloud Base)
  if (text.includes('BKN CLD') || text.includes('OVC CLD') || text.includes('CIG')) {
    const cigMatch = text.match(/(?:CIG|CLD)\s+(?:ABV|BLW)?\s*(\d+FT|FL\d{3})/);
    if (cigMatch) {
      details.push(`${this.gettextnew("Copertura nuvolosa bassa / soffitto a")} ${cigMatch[1]}`);
    } else if (text.includes('SFC') || text.includes('1000FT') || text.includes('AGL')) {
      details.push(this.gettextnew("Copertura nuvolosa bassa / soffitto ridotto"));
    }
  }

  if (details.length === 0) return rawString;

  return details.join(' • ');
},

async showFieldInfo(fieldKey) {
  const currentLang = this.lang || 'it';
  const baseUrl = process.env.BASE_URL || '/';
  
  let responseText = null;

  try {
    const fileUrl = `${baseUrl}info/${fieldKey}_${currentLang}.txt`;
    const res = await axios.get(fileUrl, { responseType: 'text' });
    responseText = res.data;
  } catch (err) {
    if (currentLang !== 'it') {
      try {
        const fallbackUrl = `${baseUrl}info/${fieldKey}_it.txt`;
        const resFallback = await axios.get(fallbackUrl, { responseType: 'text' });
        responseText = resFallback.data;
      } catch (fallbackErr) {
        console.error(`Fallback fallito per ${fieldKey}_it.txt`, fallbackErr);
      }
    }
  }

  if (responseText) {
    this.infoModalTitle = this.gettextnew('Informazioni') + ' - ' + fieldKey;
    this.infoModalContent = responseText;
    this.isInfoModalActive = true;
  } else {
    alert(this.gettextnew('Spiegazione non disponibile.'));
  }
},


    async fetchSigmetAirmet() {
      if (!this.IoT) {
        console.warn("Variabile this.IoT non ancora definita o vuota.");
        return;
      }

      try {
        const buster = this.buster || new Date().getTime(); 
        let baseUrlAlerts = '';

        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
          baseUrlAlerts = `http://localhost:8080/${this.IoT}/Sigmet_Airmet/`;
        } else {
          baseUrlAlerts = `/${this.IoT}/Sigmet_Airmet/`;
        }
        
        const resAirmet = await axios.get(`${baseUrlAlerts}airmet.json?v=${buster}`);
        this.airmetData = Object.assign({}, resAirmet.data);
        
        const resSigmet = await axios.get(`${baseUrlAlerts}sigmet.json?v=${buster}`);
        this.sigmetData = Object.assign({}, resSigmet.data);
        
      } catch (error) {
        console.error("Errore nel recupero dei file AIRMET/SIGMET per " + this.IoT, error);
      }
    },

    async fetchDensityData() {
      this.loadingDensity = true;
      try {
        const Dens_API_URL = 'https://www.climavia.city/WW_IoT_Pegaso_Query_Avio_json_Graph_Density_Altitude.php?IoT='+this.IoT;
        const response = await axios.get(Dens_API_URL);
        const rawData = response.data;
        
        if (Array.isArray(rawData)) {
            this.DensityData = rawData.map(item => ({
                date: item.timestamp,
                value: item.value.replace(',', '')
            }));

            let tuttiIDensity = [];
            this.DensityData.forEach(item => {
                tuttiIDensity.push(item.value);
            });
            this.DensityMin = Math.min(...tuttiIDensity);
            this.DensityMax = Math.max(...tuttiIDensity);

            if (this.DensityMin !== Infinity && this.DensityMax !== -Infinity) {
                const margine = (this.DensityMax - this.DensityMin) * 0.1;
                this.DensityMin = Math.floor(this.DensityMin - margine);
                this.DensityMax = Math.ceil(this.DensityMax + margine);
            }
        }
      } catch (err) {
        console.error("Errore nel recupero temperatura:", err);
      } finally {
        this.loadingDensity = false;
      }
    },

    async fetchVentoData() {
      this.loadingPress = true;
      try {
        const TEMP_API_URL = 'https://www.climavia.city/WW_IoT_Pegaso_Query_Nautico_json_Graph_Pressione.php?IoT='+this.IoT;
        const response = await axios.get(TEMP_API_URL);
        const rawData = response.data;
        
        if (Array.isArray(rawData)) {
            this.PressData = rawData.map(item => ({
                date: item.timestamp,
                value: item.value.replace(',', '')
            }));

            let tuttiIVelocita = [];
            this.PressData.forEach(item => {
                tuttiIVelocita.push(item.value);
            });
            this.PressMin = Math.min(...tuttiIVelocita);
            this.PressMax = Math.max(...tuttiIVelocita);

            if (this.PressMin !== Infinity && this.PressMax !== -Infinity) {
                const margine = (this.PressMax - this.PressMin) * 0.1;
                this.PressMin = Math.floor(this.PressMin - margine);
                this.PressMax = Math.ceil(this.PressMax + margine);
            }
        }
      } catch (err) {
        console.error("Errore nel recupero temperatura:", err);
      } finally {
        this.loadingPress = false;
      }
    },

    async fetchWindData() {
      this.loadingWind = true;
      try {
          const WIND_API_URL = 'https://www.climavia.city/WW_IoT_Pegaso_Query_Nautico_json_Graph_Vento_Raffica.php?IoT=' + this.IoT;
          const response = await axios.get(WIND_API_URL);
          const rawData = response.data;
          
          if (Array.isArray(rawData)) {
              this.windData = rawData.map(item => ({
                  date: item.Date_Time,
                  value: parseFloat(item.Wind_Speed),
                  gust: parseFloat(item.Wind_Gust)
              }));
          }
      } catch (err) {
          console.error("Errore nel recupero dati Vento:", err);
      } finally {
          this.loadingWind = false;
      }
    },

    async fetchWTempData() {
      this.loadingTmpDP = true;
      try {
          const TEMPDP_API_URL = 'https://www.climavia.city/WW_IoT_Pegaso_Query_Nautico_json_Graph_Temp_DP.php?IoT=' + this.IoT;
          const response = await axios.get(TEMPDP_API_URL);
          const rawData = response.data;
          
          if (Array.isArray(rawData)) {
              this.TempDPData = rawData.map(item => ({
                  date: item.Date_Time,
                  Temperature: parseFloat(item.Temperature),
                  dew_point: parseFloat(item.dew_point)
              }));
          }
      } catch (err) {
          console.error("Errore nel recupero dati Temperatura e DP:", err);
      } finally {
          this.loadingTmpDP = false;
      }
    },

    createAudio() {
      const uniqueUrl = this.audioURL + '?t=' + new Date().getTime();
      const newAudio = new Audio(uniqueUrl);
      newAudio.addEventListener('ended', this.onEnded);
      return newAudio;
    },

    toggleAudio() {
      if (!this.isPlaying) {
        this.resetAudio();

        this.audio = new Audio(this.audioURL + '?t=' + new Date().getTime());
        this.audio.addEventListener('ended', this.onEnded, { once: true });

        this.audio.play()
          .then(() => {
            this.isPlaying = true;
          })
          .catch(err => {
            console.error('Errore nella riproduzione audio:', err);
            this.resetAudio();
          });
      } else {
        this.resetAudio();
      }
    },

    onEnded() {
      if (this.isPlaying) {
        this.audio = new Audio(this.audioURL + '?t=' + new Date().getTime());
        this.audio.addEventListener('ended', this.onEnded, { once: true });
        
        this.audio.play().catch(err => {
          console.error('Errore nel riavvio automatico dell\'audio:', err);
          this.resetAudio();
        });
      }
    },

    resetAudio() {
      if (this.audio) {
        try {
          this.audio.pause();
          this.audio.removeEventListener('ended', this.onEnded);
        } catch (e) {
          // Ignora eventuali eccezioni
        }
        this.audio = null;
      }
      this.isPlaying = false;
    },

    beforeDestroy() {
      if (this.audio) {
        this.resetAudio();
        this.audio.pause();
        this.audio.removeEventListener('ended', this.onEnded);
      }
    },

    showYourIp() {
      fetch('https://ipapi.co/json/')
      .then(x => x.json())
      .then(({ ip, country_name, region }) => {
          this.term = ip;
          this.country = country_name;
          this.region = region;
          this.urlIP='https://www.climavia.city/IP.php?IoT='+ this.IoT + '&IP='+this.term+ '&REGION='+this.region+'&COUNTRY='+this.country;
          if (this.flag == 0){
            this.flag= 1;
            this.SendIp(this.urlIP)
          }
      });
    },

    SendIp(urlIP) {
      axios.get(urlIP)
        .then(response => {
          response.json();
        })
        .catch(error => {
          console.warn("Registrazione IP non riuscita (probabile blocco CORS o AdBlock):", error.message);
        });
    },

    LoadLanguage() {
      const baseUrl = process.env.BASE_URL || '/';
      const jsonUrl = `${baseUrl}language/climavia_01_13.json`;

      axios
        .get(jsonUrl)
        .then(response => {
          this.language = response.data;
          console.log("JSON caricato correttamente da:", jsonUrl);
        })
        .catch(error => {
          console.error("Errore nel caricamento del JSON:", error);
        });
    },

    getAll(){
      axios
      .get('https://www.climavia.city/WW_IoT_Pegaso_Query_New_TAF_json_new.php?IoT='+ this.IoT)
      .then(res => {
        if (!res.data || !res.data.INDICE0) {
          console.warn("Dati ricevuti non validi o mancanti per IoT:", this.IoT);
          this.messaggio_stato_sensore_meteo = this.gettextnew("Dati meteo locali non disponibili");
          return; 
        }
        this.users = res.data;

        this.lingua = this.lang;
        console.log("Lingua rilevata:", this.lingua);

        if (this.lingua == 'it') {
          this.lingua_atis='_IT';
        } else {
          this.lingua_atis='';
        }
        this.fetchSigmetAirmet();

        this.INDICE0=this.users.INDICE0;
        this.INDICE1=this.users.INDICE1;
        this.INDICE2=this.users.INDICE2;
        this.INDICE3=this.users.INDICE3;
        this.INDICE4=this.users.INDICE4;
        this.INDICE5=this.users.INDICE5;
        this.INDICE6=this.users.INDICE6;
        this.INDICE7=this.users.INDICE7;
        this.INDICE8=this.users.INDICE8;
        this.INDICE9=this.users.INDICE9;
        this.INDICE10=this.users.INDICE10;
        this.INDICE11=this.users.INDICE11;
        this.INDICE12=this.users.INDICE12;

        this.Accessi=this.INDICE12.CONTEGGI;
        this.Numero_Camere=this.INDICE0.Numero_Camere;

        if (this.INDICE0.visibilita == "Visib.: < 500 metri" || this.INDICE0.visibilita == "Visib.: < 100 metri" || this.INDICE0.visibilita == "Prev.Visib. Scarsa" || this.INDICE0.visibilita == "Prev.Visib. Mediocre") {
          this.visibilita_Color = "red";
        } else {
          this.visibilita_Color = this.verde;
        }

        this.tipo_sensore = this.INDICE0.tipo_sensore;
        this.intensita_pioggia = parseFloat(this.INDICE0.precip_acc * 60).toFixed(2);
        this.i=0;
        while (this.i != 6) {
            if ((this.intensita_pioggia >= this.Scala_intensita_pioggia[this.i][1]) && (this.intensita_pioggia < this.Scala_intensita_pioggia[this.i][2])){
                this.intensita_pioggia_letter = this.Scala_intensita_pioggia[this.i][0];
                this.intensita_pioggia_color = this.Scala_intensita_pioggia[this.i][3];
                break;
            }
            this.i=this.i+1;
        }

        this.MAX_RELH = this.INDICE0.MAX_RELH;
        this.Percent_chr ='%';
        if (this.MAX_RELH == "ND") {
          this.Percent_chr = ' ';
          this.MAX_RELH_Color = this.blu;
        } else {
          this.MAX_RELH = parseFloat(this.INDICE0.MAX_RELH).toFixed(0);
          if (this.MAX_RELH >= 0 && this.MAX_RELH <=35){
            this.MAX_RELH_Color = this.verde;
          } else {
            if (this.MAX_RELH > 35 && this.MAX_RELH <=55){
              this.MAX_RELH_Color = this.arancione;
            } else {
              this.MAX_RELH_Color = "red";
            }
          }
        }

        this.menodieci = parseFloat(this.INDICE0.menodieci).toFixed(0);
        this.LLWS = this.INDICE0.LLWS.replace("%","");
        if (this.LLWS == "NA"){
          this.LLWS_Color = this.blu;
        } else {
          if (this.LLWS == "00"){
            this.LLWS_Color = this.verde;
          } else {
            this.LLWS_Color = "red";
          }
        }

        this.T_today = this.INDICE0.T_today;
        this.T_tomorrow = this.INDICE0.T_tomorrow;

        if(this.T_today != "--"){
          if (parseFloat(this.T_today).toFixed(2) >= 0){
            this.T_today_Plus = "+";
          } else {
            this.T_today_Plus = "";
          }
        } else {
            this.T_today_Plus = "";
        }

        if(this.T_tomorrow != "--"){
          if (parseFloat(this.T_tomorrow).toFixed(2) >= 0){
            this.T_tomorrow_Plus = "+";
          } else {
            this.T_tomorrow_Plus = "";
          }
        } else {
            this.T_tomorrow_Plus = "";
        }

        this.uv_index = this.INDICE0.uv_raw ;
        this.i=0;
        while (this.i != 5) {
            if ((this.uv_index >= this.Scala_UV[this.i][1]) && (this.uv_index < this.Scala_UV[this.i][2])){
                this.uv = this.Scala_UV[this.i][0];
                this.uv_color = this.Scala_UV[this.i][3];
                break;
            }
            this.i=this.i+1;
        }

        this.Rain= this.INDICE0.rain;
        if (this.Rain == "Piove"){
          this.Rain_Portal = "Precipitazioni in atto";
          this.Rain_Color = "red";
        } else {
          this.Rain_Color=this.verde;
          this.Rain_Portal = "Precipitazioni";
        }

        this.lat=this.INDICE0.lat;
        this.lng=this.INDICE0.lng;

        this.tipologia = this.INDICE0.tipologia;

        this.stato = this.INDICE0.stato;
        if(this.stato == 3){
          this.Messaggio_Stato = 'Sistema Centrale OffLine';
        } else if (this.stato == 5){
          this.Messaggio_Stato = 'Sito Predisposto';
        } else if (this.stato == 4){
          this.Messaggio_Stato = 'Sito in Manutenzione';
        } else {
          this.Messaggio_Stato = 'Sistema Centrale OnLine';
        }

        this.stato_sensore_meteo=this.INDICE0.stato_sensore_meteo;
        if (this.stato_sensore_meteo == "Sensore_ON" && this.stato == 0){
          this.messaggio_stato_sensore_meteo = null;
        } else {
          this.messaggio_stato_sensore_meteo = this.gettextnew("Dati meteo locali non disponibili");
        }

        this.dvento=this.INDICE0.dvento_gradi;
        this.dvento = parseFloat(this.dvento).toFixed(0);
        this.dvento = ('00'+this.dvento).slice(-3);
        this.dvento_l=this.INDICE0.dvento;

        this.ix = parseFloat(this.INDICE0.dvento_gradi/ (360. / 16)).toFixed(0);
        this.dvento_rosa = this.dirs[this.ix % 16][1];
        this.DmediaR_ch=this.INDICE1.DmediaR_ch;

        this.QFE=this.INDICE0.QFE;
        this.QNH=this.INDICE0.QNH;
        this.Delta_QNH=this.INDICE0.Delta_Prs;
        this.QNH=(+this.QNH) + (+this.Delta_QNH);
        this.QFE=(+this.QFE) + (+this.Delta_QNH);
        this.QFE=parseFloat(this.QFE).toFixed(0);
        this.QNH=parseFloat(this.QNH).toFixed(0);
        this.EQFE=parseFloat(this.INDICE0.EQFE*3.28084).toFixed(0);
        this.Isa=(this.INDICE0.Isa).replace(/_/g, ' ');

        this.wind_ms=parseFloat(this.INDICE0.wind_ave_ms);
        this.wind_kt=(this.wind_ms*1.944).toFixed(0);

        if (this.wind_kt > 12){
          this.Wind_Color ="red";
        } else {
          this.Wind_Color =this.verde;
        }

        this.Draffica=(this.INDICE1.DmediaR);
        while (this.Draffica.length < 3) this.Draffica = "0" + this.Draffica;

        this.Raffica=parseFloat(this.INDICE4.wind_gust_10_ms*1.944).toFixed(0);

        if(this.Raffica >= 10 && this.Raffica > this.wind_kt){
          this.text_raffica1= this.gettextnew("Raffica di vento:") ;
          this.text_raffica2= this.gettextnew(" da") + " " + ('00'+this.Draffica.toFixed(0)).slice(-3) + "° " + Number(this.Raffica).toLocaleString() + " Kt";
          this.Raffica_Color = "red";
        } else if (this.wind_kt*1.3 >= 10) {
          this.text_raffica1 = this.gettextnew("Possibile raffica di vento:");
          this.text_raffica2 = this.gettextnew("  da")+ " "+  ('00'+this.Draffica.toFixed(0)).slice(-3) + "° " + Number(parseFloat(this.wind_kt * 1.3).toFixed(0)).toLocaleString() + " Kt";
          this.Raffica_Color = "red";
        } else {
          this.text_raffica1 =  this.gettextnew("Raffica di vento:");
          this.text_raffica2 =  this.gettextnew(" non significativa");
          this.Raffica_Color = this.verde;
        }

        this.IFetch=this.INDICE1.IFetch;
        if (this.IFetch == 'ND'){
          this.Moto_Ondoso = 'N.D.'
          this.Moto_Ondoso_Color = '#000000'
        } else {
          this.INDmedia = this.INDICE1.INDmedia;
          this.IVmediaR = this.INDICE1.IVmediaR;
          this.IFetch = Math.pow(this.IFetch, 0.5);
          this.IFetch = this.IFetch*0.01488;
          this.Moto_Ondoso = parseFloat(this.IFetch*this.IVmediaR*0.3).toFixed(2);
          if (this.Moto_Ondoso <= 0.10){
            this.Moto_Ondoso_Color = this.verde;
          }
          if (this.Moto_Ondoso > 0.10 && this.Moto_Ondoso <= 0.18){
            this.Moto_Ondoso_Color = this.blu;
          }
          if (this.Moto_Ondoso > 0.18 && this.Moto_Ondoso <= 0.25){
            this.Moto_Ondoso_Color = this.arancione;
          }
          if (this.Moto_Ondoso > 0.25){
            this.Moto_Ondoso_Color = this.rosso_forte;
          }
        }

        this.Devstd=this.INDICE1.Devstd;
        this.VmediaR=this.INDICE1.VmediaR;

        if(this.VmediaR == 'NAN'){
          this.VmediaR = 0;
        }

        if(this.Devstd > 70 || this.VmediaR == 0){
          this.Stringa_Vento = this.gettextnew("Spostamento massa d'aria non significativo");
        } else {
          this.Stringa_Vento = this.gettextnew("Massa aria verso") +" " + this.DmediaR_ch + "/6H/" + parseFloat(this.VmediaR*6).toFixed(0) + " Km";
        }

        this.PRS_Ultimo_minuto=parseFloat(this.INDICE2.PRS_Ultimo_minuto).toFixed(0);
        this.PRS_minuto_precedente=parseFloat(this.INDICE3.PRS_minuto_precedente).toFixed(0);

        if (this.PRS_Ultimo_minuto > this.PRS_minuto_precedente){
          this.pressione="up";
          this.pressione_l ="In aumento";
        } else if (this.PRS_Ultimo_minuto < this.PRS_minuto_precedente){
          this.pressione="down";
          this.pressione_l ="In diminuzione";
        } else {
          this.pressione="equal";
          this.pressione_l ="Stabile";
        }

        this.sunrise=this.INDICE5.sunrise;
        this.sunset=this.INDICE5.sunset;
        this.civil_twilight_begin=this.INDICE5.civil_twilight_begin;
        this.civil_twilight_end=this.INDICE5.civil_twilight_end;
        this.Rischio_Temporali=this.INDICE6.rischio;

        if (this.Rischio_Temporali == "Significativo" || this.Rischio_Temporali == "Alto") {
          this.Rischio_Temporali_Color = "red";
        } else {
          this.Rischio_Temporali_Color = this.verde;
        }

        this.Avvisi_Manutenzione = this.INDICE6.Avvisi_Manutenzione;
        this.Data_Inizio_Avvisi_Manutenzione = this.INDICE6.Data_Inizio_Avvisi_Manutenzione;
        this.Ora_Inizio_Avvisi_Manutenzione = this.INDICE6.Ora_Inizio_Avvisi_Manutenzione;
        this.Data_Fine_Avvisi_Manutenzione = this.INDICE6.Data_Fine_Avvisi_Manutenzione;
        this.Ora_Fine_Avvisi_Manutenzione = this.INDICE6.Ora_Fine_Avvisi_Manutenzione;

        if (this.tipologia == 'Elisuperficie'){
          this.Pista_Heli = "Heli_";
        } else {
          this.Pista_Heli = "Pista_";
        }

        this.Pista_Attiva=this.INDICE7.pista_attiva;

        if (this.tipologia == 'Idrosuperficie'){
          this.pista=this.Pista_Heli+this.Pista_Attiva+"_I";
        } else {
          if (this.INDICE0.num_piste == 2){
            this.pista=this.Pista_Heli+this.Pista_Attiva+"_2";
          } else {
            this.pista=this.Pista_Heli+this.Pista_Attiva;
          }
        }
        
        if (this.Pista_Attiva.length > 2){
          this.Pista_Attiva_Vis = this.Pista_Attiva.substring(0,2) + "-"+ this.Pista_Attiva.substring(2,4);
        } else {
          this.Pista_Attiva_Vis = this.Pista_Attiva;
        }
        if (this.Pista_Attiva_Vis == '00'){
            this.Pista_Attiva_Vis = '36'
        }
        if (this.Pista_Attiva_Vis == '00-18'){
            this.Pista_Attiva_Vis = '36-18'
        }

        this.Tmp3Hour=this.INDICE8.Tmp3Hour;
        this.Hum3Hour=this.INDICE8.Hum3Hour;
        this.TmpHour=this.INDICE8.TmpHour;
        this.wbHour=this.INDICE8.wbHour;
        this.TmpDay=parseFloat(this.INDICE8.TmpDay).toFixed(0);
        this.Wind_Max_15_kt = parseFloat(this.INDICE8.Wind_Max_15_kt).toFixed(0);
        this.Wind_Max_60_kt = parseFloat(this.INDICE8.Wind_Max_60_kt).toFixed(0);
        this.Wind_Max_day_kt = parseFloat(this.INDICE8.Wind_Max_day_kt).toFixed(0);
        this.data_Max_15 = this.INDICE8.data_Max_15;
        this.data_Max_60 = this.INDICE8.data_Max_60;
        this.data_Max_day = this.INDICE8.data_Max_day;
        this.Onda_Fredda = this.INDICE8.Onda_Fredda;

        this.ET = 0.4 *(this.TmpHour + this.wbHour + 4.8);

        if (this.stato != 0){
            this.iET=this.gettextnew("Indeterminata");
            this.iET_Color = "red";
        } else if (this.Onda_Fredda == 'Si_Onda_Fredda'){
            this.iET=this.gettextnew("Onda Fredda");
            this.iET_Color = "#0033cc";
        } else if (this.Onda_Fredda == 'Prev_Onda_Fredda'){
            this.iET=this.gettextnew("Prevista Onda Fredda");
            this.iET_Color = "#0033cc";
        } else if (this.ET <= 5){
            this.iET=this.gettextnew("Freddo");
            this.iET_Color = "#0033cc";
        } else if (this.ET <= 16){
            this.iET=this.gettextnew("Fresco");
            this.iET_Color = "#3399ff";
        } else if (this.ET <= 22){
            this.iET=this.gettextnew("Piacevole");
            this.iET_Color = this.verde;
        } else if (this.ET <=25){
            this.iET=this.gettextnew("Elevata");
            this.iET_Color = "#ff5c33";
        } else if (this.ET > 25){
            this.iET=this.gettextnew("Rischio colpo di calore");
            this.iET_Color = "red";
        }

        this.hum=parseFloat(this.INDICE0.hum).toFixed(0);
        this.density=parseFloat(this.INDICE0.Density_Altitude).toFixed(0);

        const diffDensity = Math.abs(parseFloat(this.density) - this.EQFE);
        this.density_Color = "green";
        if(diffDensity > 800) this.density_Color = this.arancione;
        if(diffDensity > 1500) this.density_Color = "red";

        this.freezing=parseFloat(this.INDICE0.Freezing_Level).toFixed(0);
        this.temperature=parseFloat(this.INDICE0.tmp).toFixed(0);
        this.Tmp_Max_day=parseFloat(this.INDICE8.Tmp_Max_day).toFixed(2);
        this.Tmp_Min_day=parseFloat(this.INDICE8.Tmp_Min_day).toFixed(2);
        this.data_Tmp_Max_day = this.INDICE8.data_Tmp_Max_day;
        this.data_Tmp_Min_day = this.INDICE8.data_Tmp_Min_day;

        this.dp=parseFloat(this.INDICE0.dp).toFixed(0);
        this.tpercepita=parseFloat(this.INDICE0.tpercepita).toFixed(0);

        if (parseFloat(this.INDICE8.Tmp_Max_day).toFixed(2) >= 0){
          this.Tmp_Max_dayPlus = "+";
        } else {
          this.Tmp_Max_dayPlus = "";
        }

        if (parseFloat(this.INDICE8.Tmp_Min_day).toFixed(2) >= 0){
          this.Tmp_Min_dayPlus = "+";
        } else {
          this.Tmp_Min_dayPlus = "";
        }

        if (parseFloat(this.INDICE0.tpercepita).toFixed(2) >= 0){
          this.tpercepitaPlus = "+";
        } else {
          this.tpercepitaPlus = "";
        }

        if (parseFloat(this.INDICE0.tmp).toFixed(2) >= 0){
          this.temperaturePlus = "+";
        } else {
          this.temperaturePlus = "";
        }

        if (parseFloat(this.INDICE0.dp).toFixed(2) >= 0){
          this.dpPlus = "+";
        } else {
          this.dpPlus = "";
        }

        if (parseFloat(this.INDICE0.hum).toFixed(2) >= 0){
          this.humPlus = "+";
        } else {
          this.humPlus = "";
        }

        if (parseFloat(this.INDICE8.TmpDay).toFixed(2) >= 0){
          this.TmpDayPlus = "+";
        } else {
          this.TmpDayPlus = "";
        }

        this.TrendTmp3Hour= Number(parseFloat(this.temperature-this.Tmp3Hour).toFixed(2)).toLocaleString(undefined, {minimumFractionDigits: 2});
        if (parseFloat(this.temperature-this.Tmp3Hour) >= 0){
          this.TrendTmp3HourPlus = "+";
        } else {
          this.TrendTmp3HourPlus = "";
        }

        this.TrendHum3Hour=parseFloat(this.hum-this.Hum3Hour).toFixed(2);
        if (this.hum-this.Hum3Hour >= 0){
          this.TrendHum3Hour = "+"+ this.TrendHum3Hour ;
        }

        // SBAGLIATO (usa la pista base fissa):
        // this.Trav_Pista = this.INDICE0.pista_1 * 10;

        // CORRETTO (usa la pista attiva calcolata per il vento attuale):
        let activeRunwayNum = parseInt(this.INDICE7.pista_attiva, 10);
        if (activeRunwayNum < 36) activeRunwayNum = activeRunwayNum * 10;
        this.Trav_Pista = activeRunwayNum;
        this.Trav_Dvento = parseFloat(this.dvento);
        this.Trav_VVento_kts = parseFloat(this.wind_kt);

        let diffAngolo = this.Trav_Dvento - this.Trav_Pista;

        while (diffAngolo > 180) diffAngolo -= 360;
        while (diffAngolo < -180) diffAngolo += 360;

        let headwindVal = this.Trav_VVento_kts * Math.cos(this.degrees_to_radians(diffAngolo));
        this.HeadWind_kts = Math.max(0, headwindVal).toFixed(1); 

        let crosswindVal = Math.abs(this.Trav_VVento_kts * Math.sin(this.degrees_to_radians(diffAngolo)));
        this.Trav_VVento_traverso = crosswindVal.toFixed(0);

        if (diffAngolo > 0) {
          this.CrossWind_Lato = this.gettextnew("da dx");
        } else if (diffAngolo < 0) {
          this.CrossWind_Lato = this.gettextnew("da sx");
        } else {
          this.CrossWind_Lato = "";
        }

        if (parseFloat(this.Trav_VVento_traverso) >= 9){
          this.Trav_VVento_traverso_color = "red";
        } else {
          this.Trav_VVento_traverso_color = this.verde;
        }

        this.Trig_Pista1 = this.Trav_Pista;
        this.Trig_Pista2 = this.Trig_Pista1+180;
        if (this.Trig_Pista2 > 360){
            this.Trig_Pista2 = this.Trig_Pista2-360;
        }
        if (this.Trig_Pista1 < this.Trig_Pista2){
            this.Trig_Pista1_ord = this.Trig_Pista2;
            this.Trig_Pista2_ord = this.Trig_Pista1;
        } else {
            this.Trig_Pista2_ord = this.Trig_Pista2;
            this.Trig_Pista1_ord = this.Trig_Pista1;
        }

        this.Trig_Trav1 = this.Trig_Pista1_ord - 90;
        if (this.Trig_Trav1 <= 0){
            this.Trig_Trav1 = this.Trig_Trav1+360;
        }

        this.Trig_Trav2 = this.Trig_Pista2_ord - 90;
        if (this.Trig_Trav2 <= 0){
            this.Trig_Trav2 = this.Trig_Trav2+360;
        }

        if (this.Trav_Dvento > this.Trig_Pista2_ord && this.Trav_Dvento < this.Trig_Pista1_ord){
            this.Trav_DAngolo = ('00'+this.Trig_Trav1).slice(-3);
        } else {
            this.Trav_DAngolo = ('00'+this.Trig_Trav2).slice(-3);
        }

        if (this.Trav_DAngolo == 360){
            this.Trav_DAngolo = ('00'+0).slice(-3);
        }

        const buster = new Date().getTime();
        this.Camera4 = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera4.png?updated=" + buster;
        this.Camera3 = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera3.png?updated=" + buster;
        this.Camera2 = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera2.png?updated=" + buster;
        this.Camera  = "https://www.climavia.city/"+this.IoT+"/snapshot/camera/Camera.png?updated=" + buster;
        this.Carta   = "https://www.climavia.city/"+this.IoT+"/snapshot/carta/99_image_30.gif?updated=" + buster;

        this.EDR1    = "https://www.climavia.city/"+this.IoT+"/snapshot/EDR/EDR_forecast.png?updated=" + buster;
        this.EDR2    = "https://www.climavia.city/"+this.IoT+"/snapshot/EDR/EDR_wind_shear.png?updated=" + buster;
        this.EDR3    = "https://www.climavia.city/"+this.IoT+"/snapshot/EDR/EDR_hum_temp.png?updated=" + buster;

        this.AVVISI=this.INDICE9.AVVISI;
        this.AVVISI=this.AVVISI.replaceAll("- ", "<br />- ");
        this.AVVISI=this.AVVISI.replaceAll(". ", ".<br />");
        this.AVVISI=this.gettextnew(this.AVVISI);
        this.PREVISIONI=this.INDICE9.PREVISIONE;
        this.PREVISIONI=this.PREVISIONI.replaceAll("- ", "<br />- ");
        this.PREVISIONI=this.PREVISIONI.replaceAll(". ", ".<br />");
        this.PREVISIONI=this.gettextnew(this.PREVISIONI);

        this.i=0;
        while (this.i != 13) {
            if ((this.wind_kt >= this.Scala_Beaufort[this.i][1]) && (this.wind_kt < this.Scala_Beaufort[this.i][2])){
                this.Vento_Nome = this.Scala_Beaufort[this.i][0];
                this.Vento_Beaufort = this.Scala_Beaufort[this.i][3];
                break;
            }
            this.i=this.i+1;
        }
        this.TK = (Number(parseFloat(this.temperature).toFixed(2)))+273.15;
        this.phi=(Number(parseFloat(this.hum)))/100;
        this.Ps=Math.exp(26.23-(5416/this.TK));
        this.Wcm=(0.493*this.phi*this.Ps)/this.TK;
        this.Wmm=parseFloat(this.Wcm*10).toFixed(2);
        this.Wmm_Color = this.verde;
        if (this.Wmm > 10){
          this.Wmm_Color = this.arancione;
        }
        if (this.Wmm > 20){
          this.Wmm_Color = this.rosso_forte;
        }

        this.audioURL='https://www.climavia.city/'+ this.IoT + '/ATIS/' + this.IoT  + this.lingua_atis + '.mp3';

        this.lightning_Color = this.verde;

        if (this.INDICE8.MAX_lightning_distance == 0 || this.INDICE8.MAX_lightning_distance == null  ){
          this.MAX_lightning_distance = '--';
        } else {
          this.MAX_lightning_distance=this.INDICE8.MAX_lightning_distance;
        }

        if (this.INDICE8.MIN_lightning_distance == 0 || this.INDICE8.MIN_lightning_distance == null){
          this.MIN_lightning_distance = '--';
        } else {
          this.MIN_lightning_distance=this.INDICE8.MIN_lightning_distance;
        }

        if (this.INDICE8.MIN_lightning_distance < 10 && this.INDICE8.MIN_lightning_distance > 0){
          this.lightning_Color = this.rosso_forte;
        } else {
          this.lightning_Color = this.verde;
        }

        if (this.INDICE8.lightning_count == 0){
          this.lightning_count = '--';
        } else {
          this.lightning_count=this.INDICE8.lightning_count;
        }

        this.Base_Nubi=parseFloat(this.INDICE8.Base_Nubi).toFixed(0);

        this.refreshCounter += 1;
        if (this.refreshCounter >= 20) {
            this.fetchVentoData();
            this.fetchWindData();
            this.fetchWTempData();
            this.fetchDensityData();            
            this.refreshCounter = 0;
        }
      })
      .catch(function (error,req){
        console.log(req);
        console.log(error);
      });
    },

    currentDate() {
      const options = {'day': '2-digit', 'month': 'long', 'year': 'numeric', 'hour12': false};
      options.timeZone = 'Europe/Rome';
      return new Date().toLocaleTimeString(navigator.language, options).replace(/(.*)\D\d+/, '$1');
    },

    getDstStd() { 
      const options = {'hour': '2-digit', 'minute': '2-digit', 'hour12': false};
      options.timeZone = 'Europe/Rome';
      if (new Date().getTimezoneOffset() == -60){
        this.Ora_Legale_Solare=this.std;
      } else {
        this.Ora_Legale_Solare = this.dst;
      }
    },

    getTwentyFourHourTime(amPmString) { 
      const options = {'hour': '2-digit', 'minute': '2-digit', 'hour12': false};
      options.timeZone = 'Europe/Rome';
      this.getDstStd();
      return new Date("1/1/2013 " + amPmString + this.Ora_Legale_Solare).toLocaleTimeString(navigator.language, options);
    },

    getNightorDay() { 
      const options = {'hour': '2-digit', 'minute': '2-digit', 'hour12': false};
      options.timeZone = 'Europe/Rome';
      if ((new Date().toLocaleTimeString(navigator.language, options)) > (new Date("1/1/2013 " + this.sunset + this.Ora_Legale_Solare).toLocaleTimeString(navigator.language, options)) || (new Date().toLocaleTimeString(navigator.language, options)) < (new Date("1/1/2013 " + this.sunrise + this.Ora_Legale_Solare).toLocaleTimeString(navigator.language, options))) {
        return ("Night");
      } else {
        return("Day");
      }
    },

    gettextnew(text) {
      if (!this.language) return text;

      let langToUse = this.language[this.lingua] ? this.lingua : 'en';

      if (this.language[langToUse] && this.language[langToUse][text]) {
        return this.language[langToUse][text];
      }
      return text;
    },

    myFunction() {
      this.reRender();
    },

    openDisclaimer(){
      window.open(this.Disclaimer," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },

    openATIS(){
      window.open(this.ATIS," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },

    openSat24(){
      window.open(this.Sat24," _blank", "width=1000, height=800, resizable, status, scrollbars=1, location");
    },
    openWindy(){
      window.open(this.Windy," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },

    openSWLL_00(){
      window.open(this.SWLL_00," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openSWLL_06(){
      window.open(this.SWLL_06," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openSWLL_12(){
      window.open(this.SWLL_12," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openSWLL_18(){
      window.open(this.SWLL_18," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openSnap(){
      window.open(this.Snap," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },

    openEDR1(){
      window.open(this.EDR1," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openEDR2(){
      window.open(this.EDR2," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openEDR3(){
      window.open(this.EDR3," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },

    openCarta(){
      window.open(this.Carta," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openDett(){
      window.open(this.Home_Avio_Dettagli," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },
    openLegDett(){
      window.open(this.Home_Legenda_Dettagli," _blank", "width=1000, height=600, resizable, status, scrollbars=1, location");
    },

    degrees_to_radians(degrees) {
      var pi = Math.PI;
      return degrees * (pi/180);
    },

    reRender(){}
  },

  watch: {
    activeLang(newVal) {
      this.lang = newVal;
    }
  },

  computed:{
    qnh_mmHg() {
      if (!this.QNH) return '--';
      return (parseFloat(this.QNH) * 0.750062).toFixed(1);
    },
    qnh_inHg() {
      if (!this.QNH) return '--';
      return (parseFloat(this.QNH) * 0.02953).toFixed(2);
    },


    boxEssenziateBg() {
      if (this.stato == 3 || this.stato == 4 || this.messaggio_stato_sensore_meteo != null) {
        return '#b4b4b4';
      }
      return '#ced4da';
    },

    boxEssenzialeTextStyle() {
      if (this.stato == 3 || this.stato == 4 || this.messaggio_stato_sensore_meteo != null) {
        return {
          opacity: '0.4'
        };
      }
      return {};
    },

    activeLang() {
      return this.langContext.currentLang;
    },

    Windy() {
      if (!this.lat || !this.lng) {
        return ''; 
      }
      return `https://embed.windy.com/embed2.html?&lat=${this.lat}&lon=${this.lng}&detailLat=${this.lat}&detailLon=${this.lng}&width=650&height=450&zoom=10&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=&calendar=now&pressure=true&type=map&location=coordinates&detail=&metricWind=default&metricTemp=default&radarRange=-1&updated=${this.componentKey}`;
    },

    formattedDate() {
      if (!this.lang || !this.localeMap) {
        return '';
      }
      const locale = this.localeMap[this.lang] || 'it-IT';
      return new Intl.DateTimeFormat(locale, { dateStyle: 'long' }).format(new Date());
    },

    formattedDateTime() {
      if (!this.lang || !this.localeMap) {
        return '';
      }
      const locale = this.localeMap[this.lang] || 'it-IT';
      return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(new Date());
    },

    imgOn() {
      const suffix = this.lang === 'it' ? '_IT' : '_EN';
      return `https://www.climavia.city/ALIS_ON_ACT_PORTAL${suffix}.png`;
    },

    imgOff() {
      const suffix = this.lang === 'it' ? '_IT' : '_EN';
      return `https://www.climavia.city/ALIS_OFF_ACT_PORTAL${suffix}.png`;
    },

    legalTexts() {
      if (this.lang === 'it') {
        return {
          notice: "Questo sito utilizza esclusivamente cookie tecnici necessari al suo funzionamento.",
          cookieLabel: "Cookie Policy",
          cookieLink: "/cookie-policy.html",
          privacyLabel: "Privacy Policy",
          privacyLink: "/privacy-policy.html"
        };
      } else {
        return {
          notice: "This site uses only technical cookies necessary for its operation.",
          cookieLabel: "Cookie Policy",
          cookieLink: "/cookie-policy-en.html",
          privacyLabel: "Privacy Policy",
          privacyLink: "/privacy-policy-en.html"
        };
      }
    },

    getArray() {
      if (!this.INDICE10 || !Array.isArray(this.INDICE10)) {
        return [];
      }
      return this.INDICE10.filter((item, index) => index >= 0 && item.metar);
    },

    getTafArray() {
      if (!this.INDICE11 || !Array.isArray(this.INDICE11)) {
        return [];
      }
      return this.INDICE11.filter((item, index) => index >= 0 && item.taf);
    }
  }
}
</script>

<style scoped>
.footer a {
  color: #3273dc;
  text-decoration: none;
}
.footer a:hover {
  text-decoration: underline;
}
</style>

<style>
#app {
  margin-top: 100 !important;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

button {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  margin-bottom: 20px;
}
button:hover {
  background-color: #36a26d;
}

.container {
  display: flex;
  justify-content: center;
}
img {
  cursor: pointer;
  transition: transform 0.3s;
}
img:hover {
  transform: scale(1.05);
}
</style>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/_all";
  $footer-color:true;
  @import "~bulma";
  @import "~buefy/src/scss/buefy";

.container-riga {
  display: flex;
  gap: 20px;
  width: 100%;
  padding: 10px;
}

.colonna {
  flex-shrink: 1; 
  flex-basis: 0%;
  min-width: 0;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 5px;
  flex-grow: 1;
}

.colonna-larga {
  flex-grow: 2;
}

.colonna-piccola {
  flex-grow: 0.5;
}

@media (max-width: 768px) {
  .container-riga {
    flex-direction: column;
  }
  
  .colonna, .colonna-larga, .colonna-piccola {
    flex: 1 1 100%; 
    margin-bottom: 20px; 
  }
}
</style>

<style scoped>
.back-button {
  position: fixed;
  top: 50px;
  left: 10px;
  z-index: 999;
  background: rgba(0, 0, 205, 0.1);
  color: white;
  padding: 8px 15px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
}

.back-button img {
  height: 45px;
  width: 45px;
}

.colonna-larga p {
  margin: 0 !important;
  line-height: 1.2;
}

.colonna-larga .row {
  border-bottom: 2px solid #a8b0b8;
}

.colonna-larga .row:last-child {
  border-bottom: none;
}
</style>
<style scoped>
.info-icon {
  display: inline-block;
  margin-left: 6px;
  cursor: pointer;
  font-size: 1.1rem;
  color: #007bff;
  transition: color 0.2s, transform 0.2s;
  user-select: none;
  vertical-align: middle;
}

.info-icon:hover {
  color: #0056b3;
  transform: scale(1.2);
}
</style>